import React from "react";

import {
  DeleteOutlined as DeleteOutlinedIcon,
  EditOutlined as EditOutlinedIcon,
  FileCopyOutlined as FileCopyOutlinedIcon,
  MoreHoriz as MoreHorizIcon,
  SendOutlined as SendOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
} from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { Features } from "@/config/features";
import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()({
  rootIcon: {
    width: 12,
    height: 3,
  },
  icon: {
    color: colors.primary,
    marginRight: 8,
    width: 20,
    height: 20,
  },
  text: {
    fontWeight: 600,
    color: colors.primary,
  },
  menuItem: {
    marginTop: 4,
    display: "flex",
    alignItems: "center",
  },
});

interface OptionMenuProps {
  coachId: string;
  ownerId: string;
  formId: string;
  onClickMenu: (type: string) => void;
}

const OptionMenu: React.FC<OptionMenuProps> = ({
  formId,
  onClickMenu,
  ownerId,
  coachId,
}) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleOnclick(type: string) {
    onClickMenu(type);
    handleClose();
  }

  return (
    <Box display="flex" flexDirection="row">
      <IconButton
        onClick={handleOpen}
        className={classes.rootIcon}
        size="large"
      >
        <MoreHorizIcon htmlColor={colors.grey} />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleOnclick("preview")}>
          <VisibilityOutlinedIcon className={classes.icon} />
          <Typography className={classes.text} variant="body2">
            Preview
          </Typography>
        </MenuItem>
        {coachId == ownerId && (
          <MenuItem
            component={NavLink}
            to={`/forms/${formId}/edit`}
            onClick={() => handleOnclick("edit")}
          >
            <EditOutlinedIcon className={classes.icon} />
            <Typography className={classes.text} variant="body2">
              Edit
            </Typography>
          </MenuItem>
        )}
        {Features.duplicateFormEnabled && (
          <MenuItem onClick={() => handleOnclick("duplicate")}>
            <FileCopyOutlinedIcon className={classes.icon} />
            <Typography className={classes.text} variant="body2">
              Duplicate
            </Typography>
          </MenuItem>
        )}
        <MenuItem onClick={() => handleOnclick("send")}>
          <SendOutlinedIcon className={classes.icon} />
          <Typography className={classes.text} variant="body2">
            Send
          </Typography>
        </MenuItem>
        {coachId == ownerId && (
          <MenuItem onClick={() => handleOnclick("delete")}>
            <DeleteOutlinedIcon className={classes.icon} />
            <Typography className={classes.text} variant="body2">
              Delete
            </Typography>
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};

export default OptionMenu;
